import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MediaAssetCreatorState } from './media-asset-creator.reducer';

export const MediaAssetCreatorFeatureKey = 'mediaAssetCreator';

export const selectMediaAssetCreatorState = createFeatureSelector<MediaAssetCreatorState>(
  MediaAssetCreatorFeatureKey,
);
export const selectMediaAssetCreatorRecorderState = createSelector(
  selectMediaAssetCreatorState,
  (state) => state.recorder,
);
export const selectMediaAssetCreatorVideoState = createSelector(
  selectMediaAssetCreatorState,
  (state) => state.video,
);
